import React from 'react';
import { Box, Typography, LinearProgress, CircularProgress } from '@mui/material';

const FunnelDisplay = ({ funnel, loading }) => {
  if (loading) return <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}><CircularProgress /></Box>;
  if (!funnel) return null;

  const steps = [
    { label: 'Profil megtekintések', value: funnel.views, color: '#2a5d32', pct: 100 },
    { label: 'Kapcsolat felfedés', value: funnel.contactReveals, color: '#4caf50', pct: funnel.views > 0 ? Math.round((funnel.contactReveals / funnel.views) * 100) : 0, rate: funnel.contactRate, rateLabel: 'Megtekintésből' },
    { label: 'Ajánlatkérések', value: funnel.offerRequests, color: '#f44336', pct: funnel.views > 0 ? Math.round((funnel.offerRequests / funnel.views) * 100) : 0, rate: funnel.offerRate, rateLabel: 'Kapcsolat felfedésből' },
  ];

  return (
    <Box>
      {steps.map((step, i) => (
        <Box key={step.label} sx={{ mb: i < steps.length - 1 ? 2 : 0 }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 0.5 }}>
            <Typography variant="body2" fontWeight={500}>{step.label}</Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              {step.rate !== undefined && (
                <Typography variant="caption" color="text.secondary">
                  {step.rate}% {step.rateLabel}
                </Typography>
              )}
              <Typography variant="body2" fontWeight={700}>{step.value.toLocaleString('hu-HU')}</Typography>
            </Box>
          </Box>
          <LinearProgress
            variant="determinate"
            value={step.pct}
            sx={{
              height: 10,
              borderRadius: 5,
              bgcolor: step.color + '20',
              '& .MuiLinearProgress-bar': { bgcolor: step.color, borderRadius: 5 },
            }}
          />
          {i < steps.length - 1 && (
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 0.5 }}>
              <Typography variant="caption" color="text.secondary">↓</Typography>
            </Box>
          )}
        </Box>
      ))}
    </Box>
  );
};

export default FunnelDisplay;
